import { useClassName } from "@contember/react-utils";
import { createElement } from "react";
import { toViewClass } from "../../utils/toViewClass.js";
function EditorHeading({ level, isNumbered, attributes, align, children }) {
  return createElement(
    `h${level}`,
    // Casting just to type-check the rest better.
    {
      ...attributes,
      style: {
        textAlign: align
      },
      className: useClassName("editorHeading", toViewClass("numbered", isNumbered))
    },
    children
  );
}
export {
  EditorHeading
};
//# sourceMappingURL=EditorHeading.js.map
